import type { ApiClient } from './ApiClient';

// Forme alignée sur POST /schools/:id/students/:studentId/invite-parent,
// GET /schools/:id/students/:studentId/parent-invitation et
// POST /parent-invitations/accept (AUT-18,
// apps/api/src/routes/parentInvitations.ts) — seule source de vérité pour ces
// routes. `status` est TOUJOURS dérivé côté serveur (jamais stocké).
//
// ⚠️ Pas de `'REVOKED'` ici, contrairement à `InvitationStatus` (AUT-08) : ce
// flux n'a délibérément pas de révocation en V1 — ré-inviter le même élève
// remplace l'invitation encore en attente.
export type ParentInvitationStatus = 'PENDING' | 'ACCEPTED' | 'EXPIRED';

export interface ParentInvitation {
  id: string;
  email: string;
  status: ParentInvitationStatus;
  expiresAt: string;
  acceptedAt: string | null;
  createdAt: string;
}

export interface InviteStudentParentResponse {
  invitation: ParentInvitation;
}

export function inviteStudentParent(
  client: ApiClient,
  tenantId: string,
  studentId: string,
  accessToken: string,
): Promise<InviteStudentParentResponse> {
  return client.post<InviteStudentParentResponse>(
    `/schools/${tenantId}/students/${studentId}/invite-parent`,
    {},
    { accessToken },
  );
}

export interface GetStudentParentInvitationResponse {
  invitation: ParentInvitation | null;
}

export function getStudentParentInvitation(
  client: ApiClient,
  tenantId: string,
  studentId: string,
  accessToken: string,
): Promise<GetStudentParentInvitationResponse> {
  return client.get<GetStudentParentInvitationResponse>(
    `/schools/${tenantId}/students/${studentId}/parent-invitation`,
    { accessToken },
  );
}

export interface AcceptParentInvitationResponse {
  studentId: string;
  declaredChildId: string;
}

// Requiert un utilisateur déjà authentifié AVEC l'adresse invitée (le serveur
// compare le jeton à l'utilisateur COURANT) — même contrat qu'AUT-08/PAR-04.
export function acceptParentInvitation(
  client: ApiClient,
  token: string,
  accessToken: string,
): Promise<AcceptParentInvitationResponse> {
  return client.post<AcceptParentInvitationResponse>('/parent-invitations/accept', { token }, { accessToken });
}
